import { useLocalStorage } from "@vueuse/core";

export const useTemplateStore = defineStore({
  id: "useTemplateStore",
  state: () => ({
    sidebarSm: useLocalStorage("lynx/CT/sidebarSm", false),
    rsidebarSm: useLocalStorage("lynx/CT/rsidebarSm", false),
    sidebarCt: useLocalStorage("lynx/CT/sidebarCt", "md"),
    sidebarMob: false,
    sidebarOverlay: false,
  }),
  getters: {
    sidebarSmValue: (state) => state.sidebarSm,
    rsidebarSmValue: (state) => state.rsidebarSm,
    sidebarCtValue: (state) => state.sidebarCt,
    sidebarMobValue: (state) => state.sidebarMob,
    sidebarOverlayValue: (state) => state.sidebarOverlay,
  },
  actions: {
    // uncheckQty() {
    //   console.log("xaction", this.new.qty_ok);
    //   this.new.qty_ok = false;
    //   console.log("action", this.new.qty_ok);
    // },
  },
  hydrate(state, initialState) {
    // if (process.client) {
    // }
  },
});
